<template>
  <div>
    <el-card class="box-card">
      <el-form :model="dlsorderbeizhu" ref="dlsorderbeizhuRef" label-width="82px">
        <el-form-item label="备注" class="addAdminForm">
            <el-input v-model="dlsorderbeizhu.beizhu" placeholder=""></el-input>
        </el-form-item>
        <el-form-item class="mt20">
            <el-button type="primary" @click="clicksave">添加</el-button>
            <el-button type="info" @click="clickback">返回</el-button>
        </el-form-item>
      </el-form>

      <div class="title mt20">备注记录</div>
      <el-table :data="listlog" border stripe class="mt15">
        <el-table-column prop="Beizhu" label="备注" min-width="70%"></el-table-column>
        <el-table-column prop="Adminusername" label="创建人" min-width="10%"></el-table-column>
        <el-table-column prop="Createtime" label="操作时间" min-width="20%"></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  data () {
    return {
      dlsorderbeizhu: {
        beizhu: ''
      },
      listlog: [],
      orderid: null
    }
  },
  methods: {
    LoadData (parentdata) {
      this.orderid = parentdata.params.orderid
      this.apiGeterporderbeizhulist()
    },
    clickback () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.apiAddproductorderbeizhu()
    },
    apiAddproductorderbeizhu: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: this.orderid,
        beizhu: this.dlsorderbeizhu.beizhu
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Addproductorderbeizhu, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.apiGeterporderbeizhulist()
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGeterporderbeizhulist: function (type, parentid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: this.orderid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Geterporderbeizhulist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.listlog = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.select1 {
    width: 109px;
    margin-right: 15px;
}
.speed {
    width: 440px;
    margin-right: 15px;
}
</style>
